import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAddBasketBarcodePopUp_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAddBasketBarcodePopUp_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  GetItemDetailByItemCode: any[];
  GetItemDetailByItemCode_dummy: any[];
  ChangeQty: number;
  ChangeQty_dummy: number;
  BasketAddManuel: any[];
  BasketAddManuel_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  SetValueOf: any;
  SetValueOf_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  isComp959328Visible: "visible" | "hidden";
  isComp725569Visible: "visible" | "hidden";
}

export class AddBasketBarcodePopUp_ScreenBase extends React.PureComponent<
  IAddBasketBarcodePopUp_ScreenProps,
  any
> {
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "374d503e-6321-499a-a95e-92618a37c99f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 215212, PropertyName: "placeholder", Value: "15" },
        { Id: 868316, PropertyName: "label", Value: "Ekle" },
        { Id: 959328, PropertyName: "value", Value: "Stokta" },
        { Id: 725569, PropertyName: "value", Value: "Stokta Yok" },
        { Id: 357890, PropertyName: "value", Value: "Açıklama(İsteğe Bağlı)" },
        {
          Id: 180192,
          PropertyName: "placeholder",
          Value: "Ürüne Açıklama Giriniz.",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromLocalStorage: "",
      GetItemDetailByItemCode: [],
      ChangeQty: 0,
      BasketAddManuel: [],
      Notify: false,
      SetValueOf: "",
      GoBack: "",
      isComp959328Visible: "hidden",
      isComp725569Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("addbasketbarcodepopup", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.AddBasketBarcodePopUpPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("addbasketbarcodepopup", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("addbasketbarcodepopup", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AddBasketBarcodePopUpPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      addbasketbarcodepopup_215212_value: this.state.ChangeQty,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AddBasketBarcodePopUpPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CartHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AddBasketBarcodePopUpPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AddBasketBarcodePopUpPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ItemCode ?? this.props.screenInputs.itemcode,
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AddBasketBarcodePopUp/AddBasketBarcodePopUpPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemDetailByItemCode = result?.data.getItemDetailByItemCode;
    formVars.addbasketbarcodepopup_421394_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemDetailByItemCode !== undefined
        ? stateVars.GetItemDetailByItemCode?.length > 0
          ? stateVars.GetItemDetailByItemCode[0].productDescription
          : null
        : this.state.GetItemDetailByItemCode?.length > 0
        ? this.state.GetItemDetailByItemCode[0].productDescription
        : null
    );
    formVars.addbasketbarcodepopup_161563_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemDetailByItemCode !== undefined
        ? stateVars.GetItemDetailByItemCode?.length > 0
          ? stateVars.GetItemDetailByItemCode[0].productCode
          : null
        : this.state.GetItemDetailByItemCode?.length > 0
        ? this.state.GetItemDetailByItemCode[0].productCode
        : null
    );
    formVars.addbasketbarcodepopup_447508_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemDetailByItemCode !== undefined
        ? stateVars.GetItemDetailByItemCode?.length > 0
          ? stateVars.GetItemDetailByItemCode[0].price
          : null
        : this.state.GetItemDetailByItemCode?.length > 0
        ? this.state.GetItemDetailByItemCode[0].price
        : null
    );
    stateVars.isComp959328Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetItemDetailByItemCode !== undefined
            ? stateVars.GetItemDetailByItemCode?.length > 0
              ? stateVars.GetItemDetailByItemCode[0].hasStock
              : null
            : this.state.GetItemDetailByItemCode?.length > 0
            ? this.state.GetItemDetailByItemCode[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp725569Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetItemDetailByItemCode !== undefined
            ? stateVars.GetItemDetailByItemCode?.length > 0
              ? stateVars.GetItemDetailByItemCode[0].hasStock
              : null
            : this.state.GetItemDetailByItemCode?.length > 0
            ? this.state.GetItemDetailByItemCode[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AddBasketBarcodePopUpPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AddBasketBarcodePopUpPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.addbasketbarcodepopup_421394_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemDetailByItemCode !== undefined
        ? stateVars.GetItemDetailByItemCode?.length > 0
          ? stateVars.GetItemDetailByItemCode[0].productDescription
          : null
        : this.state.GetItemDetailByItemCode?.length > 0
        ? this.state.GetItemDetailByItemCode[0].productDescription
        : null
    );

    formVars.addbasketbarcodepopup_161563_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemDetailByItemCode !== undefined
        ? stateVars.GetItemDetailByItemCode?.length > 0
          ? stateVars.GetItemDetailByItemCode[0].productCode
          : null
        : this.state.GetItemDetailByItemCode?.length > 0
        ? this.state.GetItemDetailByItemCode[0].productCode
        : null
    );

    stateVars.isComp959328Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetItemDetailByItemCode !== undefined
            ? stateVars.GetItemDetailByItemCode?.length > 0
              ? stateVars.GetItemDetailByItemCode[0].hasStock
              : null
            : this.state.GetItemDetailByItemCode?.length > 0
            ? this.state.GetItemDetailByItemCode[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp725569Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetItemDetailByItemCode !== undefined
            ? stateVars.GetItemDetailByItemCode?.length > 0
              ? stateVars.GetItemDetailByItemCode[0].hasStock
              : null
            : this.state.GetItemDetailByItemCode?.length > 0
            ? this.state.GetItemDetailByItemCode[0].hasStock
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.addbasketbarcodepopup_447508_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemDetailByItemCode !== undefined
        ? stateVars.GetItemDetailByItemCode?.length > 0
          ? stateVars.GetItemDetailByItemCode[0].price
          : null
        : this.state.GetItemDetailByItemCode?.length > 0
        ? this.state.GetItemDetailByItemCode[0].price
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AddBasketBarcodePopUpComponent_378217_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      quantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "addbasketbarcodepopup_215212_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      operation_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("MINUS", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AddBasketBarcodePopUp/AddBasketBarcodePopUpComponent_378217_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ChangeQty = result?.data.changeQty;
    formVars.addbasketbarcodepopup_215212_value = ReactSystemFunctions.value(
      this,
      stateVars.ChangeQty
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AddBasketBarcodePopUpComponent_378217_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AddBasketBarcodePopUpComponent_378217_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.addbasketbarcodepopup_215212_value = ReactSystemFunctions.value(
      this,
      this.state.ChangeQty
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AddBasketBarcodePopUpComponent_215212_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      quantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "addbasketbarcodepopup_215212_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      operation_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("VALIDATE", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AddBasketBarcodePopUp/AddBasketBarcodePopUpComponent_215212_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ChangeQty = result?.data.changeQty;
    formVars.addbasketbarcodepopup_215212_value = ReactSystemFunctions.value(
      this,
      stateVars.ChangeQty
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AddBasketBarcodePopUpComponent_215212_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AddBasketBarcodePopUpComponent_215212_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.addbasketbarcodepopup_215212_value = ReactSystemFunctions.value(
      this,
      this.state.ChangeQty
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AddBasketBarcodePopUpComponent_304838_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      quantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "addbasketbarcodepopup_215212_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      operation_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("PLUS", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AddBasketBarcodePopUp/AddBasketBarcodePopUpComponent_304838_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ChangeQty = result?.data.changeQty;
    formVars.addbasketbarcodepopup_215212_value = ReactSystemFunctions.value(
      this,
      stateVars.ChangeQty
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AddBasketBarcodePopUpComponent_304838_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AddBasketBarcodePopUpComponent_304838_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.addbasketbarcodepopup_215212_value = ReactSystemFunctions.value(
      this,
      this.state.ChangeQty
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AddBasketBarcodePopUpComponent_868316_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetItemDetailByItemCode !== undefined
            ? stateVars.GetItemDetailByItemCode?.length > 0
              ? stateVars.GetItemDetailByItemCode[0].productCode
              : null
            : this.state.GetItemDetailByItemCode?.length > 0
            ? this.state.GetItemDetailByItemCode[0].productCode
            : null
        ),
        "string"
      ),
      Quantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "addbasketbarcodepopup_215212_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "addbasketbarcodepopup_180192_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AddBasketBarcodePopUp/AddBasketBarcodePopUpComponent_868316_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketAddManuel = result?.data.basketAddManuel;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AddBasketBarcodePopUpComponent_868316_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AddBasketBarcodePopUpComponent_868316_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.BasketAddManuel !== undefined
          ? stateVars.BasketAddManuel?.length > 0
            ? stateVars.BasketAddManuel[0].message
            : null
          : this.state.BasketAddManuel?.length > 0
          ? this.state.BasketAddManuel[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AddBasketBarcodePopUpComponent_868316_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AddBasketBarcodePopUpComponent_868316_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketAddManuel !== undefined
            ? stateVars.BasketAddManuel?.length > 0
              ? stateVars.BasketAddManuel[0].success
              : null
            : this.state.BasketAddManuel?.length > 0
            ? this.state.BasketAddManuel[0].success
            : null
        ),
        true
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "addbasketbarcodepopup_215212_value",
          "string"
        ),
        1,
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.AddBasketBarcodePopUpComponent_868316_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.AddBasketBarcodePopUpComponent_868316_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AddBasketBarcodePopUpComponent_868316_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketAddManuel !== undefined
            ? stateVars.BasketAddManuel?.length > 0
              ? stateVars.BasketAddManuel[0].success
              : null
            : this.state.BasketAddManuel?.length > 0
            ? this.state.BasketAddManuel[0].success
            : null
        ),
        true
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "addbasketbarcodepopup_180192_value",
          "string"
        ),
        "",
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.AddBasketBarcodePopUpComponent_868316_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.AddBasketBarcodePopUpComponent_868316_onClick4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AddBasketBarcodePopUpComponent_868316_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketAddManuel !== undefined
            ? stateVars.BasketAddManuel?.length > 0
              ? stateVars.BasketAddManuel[0].success
              : null
            : this.state.BasketAddManuel?.length > 0
            ? this.state.BasketAddManuel[0].success
            : null
        ),
        true
      )
    ) {
      stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AddBasketBarcodePopUpPageInit();
    }
  }
}
